import {StandardFileActions} from 'app/services/standard-file-actions';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { Prefix } from 'app/models/prefix.model';
import 'rxjs/add/operator/takeUntil';
import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isStandardVersionConflict, savedStandardVersion, standardVersionBody } from 'app/services/standard-version';
import { TreeGroupPosBlockComponent } from '../tree-group-pos-service/tree-group-pos-block/tree-group-pos-block.component';
import {NewBlank} from '../../../../models/new-blank.model';
import {Standard} from '../../../../models/standard.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../../services/admin.service';
import {UserService} from '../../../../services/user.service';
import * as moment from 'moment';
import {PrefixService} from 'app/services/prefix.service';
import {AddStandardTypeComponent} from '../../create-standard/modal/add-standard-type/add-standard-type.component';
import {EditStandardTypeComponent} from '../../create-standard/modal/edit-standard-type/edit-standard-type.component';
import {StandardType} from '../../../../models/standard-type.model';
import {StandardTypesService} from '../../../../services/standard-types.service';
import {StepsControllerService} from '../../../../services/steps-controller.service';
import {ConfirmationPopupComponent} from '../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {Router} from '@angular/router';
import {TreeGroupPosService} from '../tree-group-pos-service/tree-group-pos.service';
import {ViewDocxComponent} from '../../../views/view-docx/view-docx.component';
import {ViewDocxService} from '../../../../services/view-docx.service';

const DELETE_FILE_CONFIRM = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
const CONFIRM_OK = 'ok';
const HTTP_OK = 200;
const HTTP_CREATED = 201;
const HTTP_ALREADY_EXISTS = 208;
const SAVE_STANDARD_CONFIRM = 'Save standard and continue?';
const NEW_STANDARD_STATUS = 'NEW';
const LANGUAGE_RUSSIAN = 'russian';
const LANGUAGE_ENGLISH = 'english';
const FILE_PART = 'file';
const FILE_INPUT_REFERENCE = 'standardFile';
const EMPTY_FILE_INPUT = '';
const UPLOADED_FILE_TYPES = ['RU_DOC', 'RU_PPT', 'EN_DOC', 'EN_PPT'];
const STANDARD_FILE_FIELDS = {
  RU_DOC: { field: 'ruDoc', message: 'ruDocMsg' }, RU_PPT: { field: 'ruPpt', message: 'ruPptMsg' },
  RU_PDF: { field: 'ruPdf', message: 'ruPdfMsg' }, EN_DOC: { field: 'enDoc', message: 'enDocMsg' },
  EN_PPT: { field: 'enPpt', message: 'enPptMsg' }, EN_PDF: { field: 'enPdf', message: 'enPdfMsg' }
};
const RUSSIAN_DOCUMENT = 'RU_DOC';
const FIRST_PREFIX_INDEX = 0;
const TYPES_RESPONSE_INDEX = 1;
const FIRST_DAILY_STANDARD_NUMBER = 1;
const NUMBER_SEPARATOR = '.';

@Component({
  selector: 'app-opst-step-one',
  templateUrl: './opst-step-one.component.html',
  styleUrls: ['./opst-step-one.component.css'],
})

export class OpstStepOneComponent implements OnInit, OnDestroy {
  fileActions = new StandardFileActions(this.adminService, this.modalService);
  @ViewChild(TreeGroupPosBlockComponent) private assignmentEditor: TreeGroupPosBlockComponent;
  @ViewChildren(FILE_INPUT_REFERENCE) private fileInputs: QueryList<ElementRef>;
  versionConflict = false;
  reloadFailed = false;
  private destroyed$ = new Subject<void>();
  private referenceRequest = new Subscription();
  private numberRequest = new Subscription();
  private destroyed = false;
  formData: FormData = new FormData();
  selectedType: StandardType;
  isLoaded = false;
  groupStandardId: string;
  users: any;
  groups: any;
  groupsHead: any[] = [];
  // disGtn = false;
  selectedGroupObj: any;
  standardNumber: string;
  generadedNumber: string;
  initiator: any;
  status = 'New';
  newBlanks: NewBlank[] = [];
  failedRetrieveEntities = false;
  standard: any;
  stringDate: string;
  userID = this.userService.getLocal().id;
  numberCountToday: number;
  selectedForExecute: any = [];
  selectedForConfirm: any = [];
  selectedGroupForExecute: any = [];
  selectedPosForExecute: any = [];
  selectedPosForEConfirm: any = [];
  selectedGroupHeadForConfirm: any = [];

  hasGroups = false;
  savingStandard = false;

  newRuName = '';
  newEnName = '';
  newRuAn = '';
  newEnAn = '';

  prefixErrorMsg = false;
  standardOkMsg = false;
  standardBack: any;
  tmpCurrentStandard = null;
  foundUser = false;
  foundPos = false;
  foundGroup = false;
  foundUserConfirm = false;
  foundPosConfirm = false;
  foundGroupConfirm = false;
  createAction = true;
  createActionStandardID = '';
  currentUserID: string;
  standardBaseLanguage = '';
  ruDocMsg = false;
  ruPdfMsg = false;
  ruPptMsg = false;
  enDocMsg = false;
  enPdfMsg = false;
  enPptMsg = false;
  ruFileLink = false;
  enFileLink = false;
  isDeletedruDocMsg = true;
  isDeletedruPdfMsg = true;
  isDeletedruPptMsg = true;
  isDeletedenDocMsg = true;
  isDeletedenPdfMsg = true;
  isDeletedenPptMsg = true;
  noTypeError = false;

  // Save here all Groups and Positions
  // private allGroupsAndPositions: any[] = [];
  // Save here selected Groups and Positions
  // private selectedGroupsAndPositions: any[] = [];

  constructor(private userService: UserService,
              private adminService: AdminService,
              private modalService: NgbModal,
              public viewDocxService: ViewDocxService,
              public prefixService: PrefixService,
              private router: Router,
              public standardTypesService: StandardTypesService,
              public stepsControllerService: StepsControllerService,
              public treeGroupPosService: TreeGroupPosService) {
  }

  ngOnInit() {
    this.standardBaseLanguage = this.userService.getLocal().language;
    this.isLoaded = false;

    // GET ALL HEAD'S GROUPS
    this.stepsControllerService.getAllHeadingGroups().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.groupsHead = response.body;
          if (this.groupsHead.length > 0) {
            this.hasGroups = true;
            this.stepsControllerService.dataStandardHasGroups = true;

            this.groupStandardId = this.groupsHead[0].id;
            this.selectedGroupObj = this.groupsHead[0];

            if (this.stepsControllerService.hasCurrentStandard()) {
              this.setDivisionInitiator(this.stepsControllerService.getCurrentStandard().bindingGroup.id);
            }

            this.initiator = this.userService.getLocal();
            this.isLoaded = true;
            this.retryGroups();

          } else {
            this.hasGroups = false;
            this.stepsControllerService.dataStandardHasGroups = false;

            this.isLoaded = true;
          }
        }
      },
      () => {
        this.failedRetrieveEntities = true;
      },
      () => {
      }
    );

    // Если просто открыть.
    if (!this.stepsControllerService.hasCurrentStandard()) {
      // Data
      this.stringDate = moment().format('DD.MM.YYYY');
    } else {
      // Если зайти со списка!
      this.tmpCurrentStandard = this.stepsControllerService.getCurrentStandard();
      this.stringDate = this.tmpCurrentStandard.creationDate;

      this.newRuName = this.tmpCurrentStandard.ruName;
      this.newEnName = this.tmpCurrentStandard.enName;
      this.newRuAn = this.tmpCurrentStandard.ruAnnotation;
      this.newEnAn = this.tmpCurrentStandard.enAnnotation;

      // Установить выбранными пользователей для исполнения
      if (this.tmpCurrentStandard.linkedUsers.length > 0) {
        for (const userExecute of this.tmpCurrentStandard.linkedUsers) {
          this.selectItem(userExecute);
        }
      }

      // Установить выбранными пользователей для утверждения
      if (this.tmpCurrentStandard.confirmedUsers.length > 0) {
        for (const userForConfirm of this.tmpCurrentStandard.confirmedUsers) {
          this.fieldsChangeTmp(userForConfirm);
        }
      }

      // Установить выбранными группы для утверждения
      if (this.tmpCurrentStandard.confirmedGroups.length > 0) {
        for (const groupForConfirm of this.tmpCurrentStandard.confirmedGroups) {
          this.fieldsChangeGroupHeadTmp(groupForConfirm);
        }
      }

      // Установить выбранными позиции для исполнения
      if (this.tmpCurrentStandard.linkedPositions.length > 0) {
        for (const posExecute of this.tmpCurrentStandard.linkedPositions) {
          this.selectPosItem(posExecute);
        }
      }

      // Установить выбранными позиции для утверждения
      if (this.tmpCurrentStandard.confirmedPositions.length > 0) {
        for (const posForConfirm of this.tmpCurrentStandard.confirmedPositions) {
          this.fieldsChangePosTmp(posForConfirm);
        }
      }

      // Files for step 2
      if (this.tmpCurrentStandard.ruDoc !== null) {
        this.ruDocMsg = true;
      }
      if (this.tmpCurrentStandard.ruPdf !== null) {
        this.ruPdfMsg = true;
      }
      if (this.tmpCurrentStandard.ruPpt !== null) {
        this.ruPptMsg = true;
      }
      if (this.tmpCurrentStandard.enDoc !== null) {
        this.enDocMsg = true;
      }
      if (this.tmpCurrentStandard.enPdf !== null) {
        this.enPdfMsg = true;
      }
      if (this.tmpCurrentStandard.enPpt !== null) {
        this.enPptMsg = true;
      }

      if (this.tmpCurrentStandard.ruFileLink !== null) {
        this.ruFileLink = true;
      }
      if (this.tmpCurrentStandard.enFileLink !== null) {
        this.enFileLink = true;
      }
    }

    this.currentUserID = localStorage.getItem('User');
  }

  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });
  }

  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);
    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });
  }

  deleteFileDOCX(fileLink: string, type: string, fileId: string): void {
    this.fileActions.remove(this.tmpCurrentStandard, {type: type, fileId: fileId, link: fileLink}, () => this.finishFileRemoval(type));
  }

  deleteExistFile(type: string, fileId: string): void {
    this.fileActions.remove(this.tmpCurrentStandard, {type: type, fileId: fileId}, () => this.finishFileRemoval(type));
  }

  private finishFileRemoval(type: string): void {
    this.clearDeletedFile(type);
    this.ruFileLink = !!this.tmpCurrentStandard.ruFileLink;
    this.enFileLink = !!this.tmpCurrentStandard.enFileLink;
    this.setFileDeletionFinished(true);
  }


  private clearDeletedFile(fileType: string): void {
    const fields = STANDARD_FILE_FIELDS[fileType];
    if (!fields) { return; }
    this.tmpCurrentStandard[fields.field] = null;
    this[fields.message] = false;
    if (fileType === RUSSIAN_DOCUMENT) { this.stepsControllerService.stepThreeDisabled = true; }
  }

  private setFileDeletionFinished(finished: boolean): void {
    this.isDeletedruDocMsg = finished;
    this.isDeletedruPdfMsg = finished;
    this.isDeletedruPptMsg = finished;
    this.isDeletedenDocMsg = finished;
    this.isDeletedenPdfMsg = finished;
    this.isDeletedenPptMsg = finished;
  }

  ngOnDestroy(): void {
    this.fileActions.ngOnDestroy();
    this.destroyed = true;
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  downloadSFile(fileID) {
    this.userService.getFile(fileID).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }
    );
  }

  deleteSBlankFile(blank) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteBlankFromStandard(blank, {id: this.stepsControllerService.getCurrentStandard().id}).subscribe(
          (response: any) => {
            if (response.status === 200) {
              const index = this.tmpCurrentStandard.blanks.indexOf(blank);
              this.tmpCurrentStandard.blanks.splice(index, 1);
            }
          },
          () => {
          }
        );
      }
    });
  }

  // UPDATE TYPES IN TYPES LIST IN SERVICE
  updateTypes(listOfTypes) {
    if (listOfTypes !== null && listOfTypes !== undefined) {
      this.prefixService.updateTypesList(listOfTypes);
    } else {
      this.prefixService.updateTypesList([]);
    }
    if (this.tmpCurrentStandard && this.tmpCurrentStandard.standardType) {
      this.standardTypesService.setSelectedType(this.tmpCurrentStandard.standardType);
    }
  }

retryGroups(): void {
    this.referenceRequest.unsubscribe();
    const groupId = this.selectedGroupObj.id;
    this.referenceRequest = Observable.forkJoin(this.prefixService.getPrefixesForGroup(groupId),
      this.standardTypesService.getTypesForGroup(groupId)).takeUntil(this.destroyed$)
      .subscribe(responses => this.acceptReferences(responses), () => { this.failedRetrieveEntities = true; });
  }

  private acceptReferences(responses: [HttpResponse<Prefix[]>, HttpResponse<Object>]): void {
    const prefixes = responses[FIRST_PREFIX_INDEX].body || [];
    this.prefixService.setGroupPrefixex(prefixes);
    this.prefixService.setSelectedPrefix(prefixes[FIRST_PREFIX_INDEX]);
    this.setCounterNum(prefixes[FIRST_PREFIX_INDEX]);
    this.updateTypes(responses[TYPES_RESPONSE_INDEX].body || []);
  }

  // ПРОВЕРКА ВЫБРАН ЛИ ЭЛЕМЕНТ
  selectItem(user) {
    if (this.isSelectedUser(user)) {
      const index = this.selectedForExecute.findIndex(x => x.id === user.id);
      if (index !== -1) {
        this.selectedForExecute.splice(index, 1);
      }
    } else {
      this.selectedForExecute.push(user);
    }
  }

  selectPosItem(pos) {
    if (this.isSelectedPos(pos)) {
      const index = this.selectedPosForExecute.findIndex(x => x.id === pos.id);
      if (index !== -1) {
        this.selectedPosForExecute.splice(index, 1);
      }
    } else {
      this.selectedPosForExecute.push(pos);
    }
  }

  isSelectedUser(user) {
    this.foundUser = false;
    if (this.selectedForExecute.length > 0) {
      for (const grp of this.selectedForExecute) {
        if (grp.id === user.id) {
          this.foundUser = true;
          break;
        }
      }
    }
    return this.foundUser;
  }

  isSelectedPos(pos) {
    this.foundPos = false;
    if (this.selectedPosForExecute.length > 0) {
      for (const grp of this.selectedPosForExecute) {
        if (grp.id === pos.id) {
          this.foundPos = true;
          break;
        }
      }
    }
    return this.foundPos;
  }

  isSelectedUserConfirm(user) {
    this.foundUserConfirm = false;
    if (this.selectedForConfirm.length > 0) {
      for (const grp of this.selectedForConfirm) {
        if (grp.id === user.id) {
          this.foundUserConfirm = true;
          break;
        }
      }
    }
    return this.foundUserConfirm;
  }

  isSelectedGroupHeadConfirm(group) {
    this.foundGroupConfirm = false;
    if (this.selectedGroupHeadForConfirm.length > 0) {
      for (const grp of this.selectedGroupHeadForConfirm) {
        if (grp.id === group.id) {
          this.foundGroupConfirm = true;
          break;
        }
      }
    }
    return this.foundGroupConfirm;
  }

  isSelectedPosConfirm(pos) {
    this.foundPosConfirm = false;
    if (this.selectedPosForEConfirm.length > 0) {
      for (const grp of this.selectedPosForEConfirm) {
        if (grp.id === pos.id) {
          this.foundPosConfirm = true;
          break;
        }
      }
    }
    return this.foundPosConfirm;
  }

  fieldsChangeTmp(user) {
    if (!this.isSelectedUserConfirm(user)) {
      this.selectedForConfirm.push(user);
    }
  }

  fieldsChangeGroupHeadTmp(group) {
    if (!this.isSelectedGroupHeadConfirm(group)) {
      this.selectedGroupHeadForConfirm.push(group);
    }
  }

  fieldsChangePosTmp(pos) {
    if (!this.isSelectedPosConfirm(pos)) {
      this.selectedPosForEConfirm.push(pos);
    }
  }

  setDivisionInitiator(groupID) {
    const groupObj = this.groupsHead.find(i => i.id === groupID);
    this.selectedGroupObj = groupObj;
    this.groupStandardId = groupID;
    this.retryGroups();
  }

  setNumberPrefix(prefixName) {
    const prefixObj = this.prefixService.getGroupPrefixex().find(i => i.name === prefixName);
    this.prefixService.setSelectedPrefix(prefixObj);
    this.setCounterNum(prefixObj);
  }

setCounterNum(prefix: Prefix): void {
    this.numberRequest.unsubscribe();
    if (this.stepsControllerService.hasCurrentStandard()) {
      this.standardNumber = this.stepsControllerService.getCurrentStandard().number;
      return;
    }
    this.applyNumber(prefix, FIRST_DAILY_STANDARD_NUMBER);
    if (!prefix) { return; }
    this.numberRequest = this.prefixService.getCountStandardNumber(prefix.id).takeUntil(this.destroyed$)
      .subscribe(response => this.applyNumber(prefix, Number(response.body) + FIRST_DAILY_STANDARD_NUMBER),
        () => { this.failedRetrieveEntities = true; });
  }

  private applyNumber(prefix: Prefix, number: number): void {
    this.numberCountToday = number;
    this.generadedNumber = NUMBER_SEPARATOR + number + NUMBER_SEPARATOR + this.stringDate;
    this.standardNumber = this.prefixService.getNumberPrefix(prefix) + this.generadedNumber;
  }

  // Create new type window
  openAddNewTypeModal() {
    const modalRef = this.modalService.open(AddStandardTypeComponent);
    modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.noTypeError = false;
      }
    });
  }

  // Edit type window
  openEditTypeModal() {
    const modalRef = this.modalService.open(EditStandardTypeComponent);
    modalRef.componentInstance.setTypeMainGroup(this.selectedGroupObj);
  }

  setType(typeID) {
    const typeObj = this.standardTypesService.getTypesList().find(i => i.id === typeID);
    this.standardTypesService.setSelectedType(typeObj);
    this.selectedType = typeObj;
  }

  isValid() {
    if (this.stepsControllerService.getLocalUserLanguage() === 'Ru') {

      if (this.newRuName.trim().length > 0 &&
        this.newRuAn.trim().length > 0 &&
        this.formData.has('RU_DOC') &&
        this.checkListsLengthExecute()) {
        this.stepsControllerService.setDataStandard(this.getDataStandard(), this.formData, this.newBlanks);
        this.stepsControllerService.unlockStepThree(true);
      } else {
        this.stepsControllerService.unlockStepThree(false);
      }
      return (
        this.newRuName.trim().length > 0 &&
        this.newRuAn.trim().length > 0 &&
        this.formData.has('RU_DOC') &&
        this.checkListsLengthExecute());
    }

    if (this.stepsControllerService.getLocalUserLanguage() === 'En') {

      if (this.newEnName.trim().length > 0 &&
        this.newEnAn.trim().length > 0 &&
        this.formData.has('EN_DOC') &&
        this.checkListsLengthExecute()) {
        this.stepsControllerService.setDataStandard(this.getDataStandard(), this.formData, this.newBlanks);
        this.stepsControllerService.unlockStepThree(true);
      } else {
        this.stepsControllerService.unlockStepThree(false);
      }

      return (
        this.newEnName.trim().length > 0 &&
        this.newEnAn.trim().length > 0 &&
        this.formData.has('EN_DOC') &&
        this.checkListsLengthExecute());
    }
  }

  checkListsLengthExecute() {
    return this.treeGroupPosService.isValid();
  }

  qCreateQuest() {
    if (this.savingStandard || this.versionConflict || this.fileActions.pending || this.fileActions.requiresReload || this.destroyed) { return; }
    if (!this.standardTypesService.getTypesList().length) { this.noTypeError = true; return; }
    this.noTypeError = false;
    if (!this.prefixService.getSelectedPrefix()) { this.prefixErrorMsg = true; return; }
    const snapshot = this.tmpCurrentStandard;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = SAVE_STANDARD_CONFIRM;
    modalRef.result.then(result => {
      if (result === CONFIRM_OK && !this.destroyed && snapshot === this.tmpCurrentStandard) { this.createNewStandard(); }
    }, () => {});
  }

  createNewStandard() {
    if (this.savingStandard || this.versionConflict || this.fileActions.pending || this.fileActions.requiresReload || this.destroyed || !this.treeGroupPosService.areOperationTargetsReady()) { return; }
    this.startStandardSave();
    const current = this.tmpCurrentStandard || this.stepsControllerService.getCurrentStandard();
    this.createAction = !current || !current.id;
    this.createActionStandardID = current && current.id;
    const data = this.continuesToQuestions() ? this.stepsControllerService.dataStandard : this.getDataStandard();
    this.stepsControllerService.createOrUpdateHeadStandard(data, this.createAction, this.createActionStandardID)
      .takeUntil(this.destroyed$).subscribe(
        response => this.acceptStandardSave(response), error => this.failStandardSave(error)
      );
  }

  private continuesToQuestions(): boolean {
    return !!(this.stepsControllerService.unlockSThree && this.stepsControllerService.dataStandard);
  }

  private startStandardSave(): void {
    this.savingStandard = true;
    this.stepsControllerService.disGtn = true;
    this.prefixErrorMsg = false;
    this.standardOkMsg = false;
    this.stepsControllerService.dataStandardFilesUploadError = false;
    this.stepsControllerService.dataStandardErrorExists = false;
    this.stepsControllerService.dataStandardErrorCreating = false;
  }

  private acceptStandardSave(response: HttpResponse<Object>): void {
    if ((response.status === HTTP_OK || response.status === HTTP_CREATED) && response.body) {
      this.standardBack = Object.assign({}, response.body);
      const version = savedStandardVersion(response);
      if (version != null) { this.standardBack.version = version; }
      this.tmpCurrentStandard = this.standardBack;
      this.stepsControllerService.currentStandard = this.standardBack;
      this.uploadFiles();
      return;
    }
    this.failStandardSave({});
    this.stepsControllerService.dataStandardErrorExists = response.status === HTTP_ALREADY_EXISTS;
    this.stepsControllerService.dataStandardErrorCreating = !this.stepsControllerService.dataStandardErrorExists;
  }

  private failStandardSave(error): void {
    this.savingStandard = false;
    this.stepsControllerService.disGtn = false;
    this.standardOkMsg = false;
    this.versionConflict = isStandardVersionConflict(error);
    this.stepsControllerService.dataStandardErrorCreating = !this.versionConflict && !this.stepsControllerService.dataStandardFilesUploadError;
  }

  private failStandardFiles(error): void {
    this.stepsControllerService.dataStandardFilesUploadError = true;
    this.failStandardSave(error);
  }

  private uploadFiles() {
    const continueToQuestions = this.continuesToQuestions();
    const files = continueToQuestions ? this.stepsControllerService.dataStandardFormData : this.formData;
    if (!continueToQuestions && !UPLOADED_FILE_TYPES.some(type => files.has(type))) {
      this.uploadBlanks(this.standardBack);
      return;
    }
    this.adminService.uploadFiles(this.standardBack, files).takeUntil(this.destroyed$).subscribe(
      () => this.uploadBlanks(this.standardBack), error => this.failStandardFiles(error)
    );
  }

  private uploadBlanks(standard: Standard) {
    const selected = this.continuesToQuestions() ? this.stepsControllerService.dataStandardNewBlanks : this.newBlanks;
    const blanks = selected.filter(blank => blank.formData && blank.formData.get(FILE_PART));
    if (!blanks.length) { this.completeAction(); return; }
    this.adminService.uploadBlank(standard, blanks).takeUntil(this.destroyed$).subscribe(
      () => this.completeAction(), error => this.failStandardFiles(error)
    );
  }

  completeAction() {
    if (this.isValid()) {

      // Убрать это в комменты, когда починятся файлы.
      this.stepsControllerService.setCurrentStandard(this.standardBack);
      this.standardOkMsg = true;
      this.stepsControllerService.stepThreeDisabled = false;
      this.stepsControllerService.activeStep = 3;

      // FOR CONTROL NEXT BUTTON IN 2'nd STEP
      this.stepsControllerService.nextToCreate = false;
      this.stepsControllerService.unlockSThree = false;
      this.stepsControllerService.dataStandard = null;
      this.stepsControllerService.dataStandardFormData = null;
      this.stepsControllerService.dataStandardNewBlanks = null;

      this.stepsControllerService.disGtn = false;
      // Files upload error message;
      this.stepsControllerService.dataStandardFilesUploadError = false;
      this.savingStandard = false;

      this.router.navigate(['/dashboard/create-operating-standard/step-three']);

    } else if (this.stepsControllerService.dataStandard) {

      // Убрать это в комменты, когда починятся файлы.
      this.stepsControllerService.setCurrentStandard(this.standardBack);
      this.standardOkMsg = true;
      this.stepsControllerService.stepThreeDisabled = false;
      this.stepsControllerService.activeStep = 3;

      // FOR CONTROL NEXT BUTTON IN 2'nd STEP
      this.stepsControllerService.nextToCreate = false;
      this.stepsControllerService.unlockSThree = false;
      this.stepsControllerService.dataStandard = null;
      this.stepsControllerService.dataStandardFormData = null;
      this.stepsControllerService.dataStandardNewBlanks = null;

      this.stepsControllerService.disGtn = false;
      // Files upload error message;
      this.stepsControllerService.dataStandardFilesUploadError = false;
      this.savingStandard = false;

      this.router.navigate(['/dashboard/create-operating-standard/step-three']);

    } else {

      this.stepsControllerService.clearCurrentStandard();
      this.standardOkMsg = true;
      this.stepsControllerService.stepOneDisabled = false;
      this.stepsControllerService.stepTwoDisabled = false;
      this.stepsControllerService.activeStep = 1;

      this.stepsControllerService.disGtn = false;
      this.savingStandard = false;
      this.router.navigate(['/dashboard/operating-standards']);
    }
  }

  getDataStandard() {
    return standardVersionBody(this.tmpCurrentStandard,
      Object.assign(this.standardIdentity(), this.standardText(), this.standardAssignments()));
  }

  private standardIdentity() {
    const type = this.standardTypesService.getSelectedType();
    return {
      number: this.standardNumber,
      creationDate: this.stringDate, authorId: this.initiator.id, groupId: this.selectedGroupObj.id,
      standardType: type === undefined ? null : { id: type.id, ruName: type.ruName, enName: type.enName },
      status: NEW_STANDARD_STATUS, language: this.standardBaseLanguage
    };
  }

  private standardText() {
    return {
      ruName: this.standardBaseLanguage === LANGUAGE_ENGLISH ? null : this.newRuName,
      ruAnnotation: this.standardBaseLanguage === LANGUAGE_ENGLISH ? null : this.newRuAn,
      enName: this.standardBaseLanguage === LANGUAGE_RUSSIAN ? null : this.newEnName,
      enAnnotation: this.standardBaseLanguage === LANGUAGE_RUSSIAN ? null : this.newEnAn
    };
  }

  private standardAssignments() {
    return {
      linkedGroups: this.selectedGroupForExecute.map(item => item.id),
      confirmedGroups: this.selectedGroupHeadForConfirm.map(item => item.id),
      linkedUsers: this.selectedForExecute.map(item => item.id),
      confirmedUsers: this.selectedForConfirm.map(item => item.id),
      linkedPositions: this.selectedPosForExecute.map(item => item.id),
      confirmedPositions: this.selectedPosForEConfirm.map(item => item.id),
      standardDisseminationPositions: this.treeGroupPosService.getReadeForServer().map(item =>
        Object.assign({}, item, { onlyHeadConfirm: item.onlyHeadConfirm === undefined ? false : item.onlyHeadConfirm }))
    };
  }

  reloadStandardDraft(): void {
    if (this.savingStandard || this.fileActions.pending || !this.tmpCurrentStandard) { return; }
    this.savingStandard = true;
    this.stepsControllerService.disGtn = true;
    this.reloadFailed = false;
    this.adminService.getStandard(this.tmpCurrentStandard.id).takeUntil(this.destroyed$).subscribe(
      response => this.acceptStandardReload(response),
      () => { this.savingStandard = false; this.stepsControllerService.disGtn = false;
        this.reloadFailed = true; }
    );
  }

  private acceptStandardReload(response: HttpResponse<Object>): void {
    this.savingStandard = false;
    this.stepsControllerService.disGtn = false;
    if (response.status !== HTTP_OK || !response.body) { this.reloadFailed = true; return; }
    this.tmpCurrentStandard = Object.assign({}, response.body);
    const version = savedStandardVersion(response);
    if (version != null) { this.tmpCurrentStandard.version = version; }
    this.stepsControllerService.currentStandard = this.tmpCurrentStandard;
    this.resetStandardDraft();
    this.resetStandardFiles();
    this.fileActions.reset();
    this.versionConflict = false;
    this.stepsControllerService.dataStandardErrorCreating = false;
    this.stepsControllerService.dataStandardFilesUploadError = false;
    if (this.assignmentEditor) { this.assignmentEditor.reloadStoredSelections(); }
  }

  private resetStandardDraft(): void {
    const standard = this.tmpCurrentStandard;
    this.newRuName = standard.ruName;
    this.newEnName = standard.enName;
    this.newRuAn = standard.ruAnnotation;
    this.newEnAn = standard.enAnnotation;
    this.standardBaseLanguage = standard.language;
    this.selectedForExecute = standard.linkedUsers.slice();
    this.selectedForConfirm = standard.confirmedUsers.slice();
    this.selectedGroupForExecute = standard.linkedGroups.slice();
    this.selectedGroupHeadForConfirm = standard.confirmedGroups.slice();
    this.selectedPosForExecute = standard.linkedPositions.slice();
    this.selectedPosForEConfirm = standard.confirmedPositions.slice();
    this.selectedType = standard.standardType;
    this.standardTypesService.setSelectedType(standard.standardType);
    this.setDivisionInitiator(standard.bindingGroup.id);
    this.stepsControllerService.dataStandard = null;
    this.stepsControllerService.unlockSThree = false;
  }

  private resetStandardFiles(): void {
    this.formData = new FormData();
    if (this.fileInputs) { this.fileInputs.forEach(input => input.nativeElement.value = EMPTY_FILE_INPUT); }
    this.newBlanks = [];
    this.stepsControllerService.dataStandardFormData = this.formData;
    this.stepsControllerService.dataStandardNewBlanks = this.newBlanks;
    Object.keys(STANDARD_FILE_FIELDS).forEach(type => {
      const fields = STANDARD_FILE_FIELDS[type];
      this[fields.message] = !!this.tmpCurrentStandard[fields.field];
    });
    this.ruFileLink = !!this.tmpCurrentStandard.ruFileLink;
    this.enFileLink = !!this.tmpCurrentStandard.enFileLink;
  }

  fileChange(type: string, event) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.formData.set(type, file, file.name);
    } else {
      this.formData.delete(type);
      // And delete TYPE in stepsControllerService for NEXT button
      if (this.stepsControllerService.dataStandardFormData) {
        this.stepsControllerService.dataStandardFormData.delete((type));
      }
    }
  }

  addNewBlank() {
    this.newBlanks.unshift(new NewBlank(null, null, null));
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  deleteBlank(key) {
    if (key > -1) {
      this.newBlanks.splice(key, 1);
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-one/opst-step-one.component.ts